import AxiosServices from "./AxiosServices";


export const getCurrentSaleTermsPolicy = async (params: { clientId: string, language: string }) => {
  const queryString = new URLSearchParams(params).toString()
  const endpoint = `/sale-terms/current?${queryString}`
  return AxiosServices.get(endpoint);

};

export const getCurrentTermsOfUsePolicy = async (params: { clientId: string, language: string }) => {
  const queryString = new URLSearchParams(params).toString()
  const endpoint = `/terms-of-use/current?${queryString}`
  return AxiosServices.get(endpoint);

};

export const getCurrentPersonnalDataPolicy = async (params: { clientId: string, language: string }) => {
  const queryString = new URLSearchParams(params).toString()
  const endpoint = `/personnal-data-terms-of-use/current?${queryString}`
  return AxiosServices.get(endpoint);

};


export const getCurrentSalesPolicy = async (params: { clientId: string, language: string }) => {
  const queryString = new URLSearchParams(params).toString()
  const endpoint = `/sales-terms/current?${queryString}`
  return AxiosServices.get(endpoint);

};


